import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { ApolloError } from '@apollo/client';

const useGraphQLErrorDisplay = (error: ApolloError | undefined): void => {
  const scnackbar = useSnackbar();

  useEffect(() => {
    if (!error) return;

    const graphQLErrors = Array.isArray(error.graphQLErrors) ? error.graphQLErrors : [];

    if (graphQLErrors.length > 0) {
      graphQLErrors.forEach((err) => {
        if (!err?.message) return;
        scnackbar.enqueueSnackbar(err.message, {
          variant: 'error',
        });
      });
      return;
    }

    const fallbackMessage = error.networkError?.message || error.message;
    if (!fallbackMessage) return;

    scnackbar.enqueueSnackbar(fallbackMessage, {
      variant: 'error',
    });
  }, [error, scnackbar]);
};

export default useGraphQLErrorDisplay;
